<script lang="ts" module>
  import { Accordion } from 'melt/builders';

  import { Assistant as AssistantNext } from '@/ui/elements/assistant/next';
  import {
    toExpandableCards,
    useAssistantState,
  } from '@/ui/elements/assistant/next/assistant-state.svelte';
  import { setAccordionContext } from '@/ui/elements/assistant/next/helpers/accordion-context';
  import LoadingCards from '@/ui/elements/card/LoadingCards.svelte';
  import { useActiveText } from '@/utils/teo-context';
  import { useAnalysisPending } from '@/utils/teo-context/teoAtom';

  const LOADING_CARDS = 3;
</script>

<script lang="ts">
  let teoText = useActiveText();
  let wordLists = teoText.current.wordLists.dictionary;

  let loading = useAnalysisPending();

  let { cards, focusedEntry, onDimensionChange } = useAssistantState(wordLists);

  let extendedCards = $derived(loading.current ? [] : toExpandableCards(cards.current));

  const accordion = new Accordion({
    onValueChange: onDimensionChange,
  });

  let lastDimensionProp: string | undefined;

  $effect(() => {
    let dimensionProp = focusedEntry.current?.key;
    if (dimensionProp === lastDimensionProp) return;

    if (dimensionProp) {
      const id = dimensionProp;
      const item = extendedCards.find((item) => item.id === id);
      if (item) {
        const action = dimensionProp ? 'expand' : 'collapse';
        accordion?.getItem(item)[action]();
      }
    } else if (lastDimensionProp) {
      accordion?.collapse(lastDimensionProp);
    }

    lastDimensionProp = dimensionProp;
  });

  setAccordionContext(accordion);
</script>

<AssistantNext.Header title="Einträge" value={cards.current.length} loading={loading.current}
></AssistantNext.Header>

<AssistantNext.Panel {...accordion.root}>
  <LoadingCards loading={loading.current} count={LOADING_CARDS}></LoadingCards>

  {#if extendedCards?.length}
    {#each extendedCards as extendedCard (extendedCard.id)}
      {@const item = accordion.getItem(extendedCard)}
      <AssistantNext.AiCard
        {...item}
        heading={item.heading}
        trigger={item.trigger}
        content={item.content}
        onImprovementClick={(suggestionKey: string) => {
          wordLists.useSuggestion(suggestionKey);
        }}
        onLoadAiSuggestionClick={() => wordLists.addAiSuggestion()}
      ></AssistantNext.AiCard>
    {/each}
  {/if}

  {#if extendedCards?.length === 0 && !loading.current}
    <AssistantNext.DoneCard></AssistantNext.DoneCard>
  {/if}
</AssistantNext.Panel>
